export default "__VITE_ASSET__qRbHOjgG__"